export default {
    listByUser: "Books for You!",
    readed: "Readed"
}
  